import { action } from "satcheljs";

const resetMyShiftStore = action(
    "RESET_MYSHIFT_STORE",
    () => ({})
);

export default resetMyShiftStore;